import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { KpiData } from '@app/shared/models/ipm/KpiData';

import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-charts-kpi',
    templateUrl: './charts-kpi.component.html',
    styleUrls: ['./charts-kpi.component.scss'],
    standalone: false
})
export class ChartsKpiComponent implements OnInit, OnDestroy {

  alive: boolean = true;

  textColorNumberCard: string;
  _aKpisData: Array<KpiData>;

  overCommCurrency:string;

  @Input() kpis: KpiData[];
  @Input() currencyCode : string;
  @Input() userLocale: string;

  constructor(
    private translateService: TranslateService
  ) {
    this.textColorNumberCard = '#00167E';
    this._aKpisData = new Array();
  }

  ngOnInit() {

    this.userLocale;

    if (this.kpis) {
      this._aKpisData = this.kpis;

      this._aKpisData.forEach((k: KpiData) => {
        this.translateService.get(k.name).pipe(takeWhile(() => this.alive)).subscribe(value => {
          if (k.name === "Over Commission") {
            this.overCommCurrency = value;
          }
          k.name = value;
          k.value = k.value + "¿"+this.userLocale+"¿";
        });
      });
      if (this.overCommCurrency !== undefined) {
        this._aKpisData[0].name = this.overCommCurrency + ' (' + this.currencyCode + ')';
      }
    }
  }

  public format(c) : string {
    let userLang = String(c.value);
    let theValue = String(c.value);

    theValue = theValue.substring(0,theValue.indexOf("¿"));

    userLang = userLang.substring(userLang.indexOf("¿") + 1,userLang.lastIndexOf("¿"));

    if (c.label.includes('%')) { // '% Over Commission'

      const number = Math.round(parseFloat(theValue) * 100) / 100;

      theValue = number.toLocaleString(userLang);

      if (! Number.isInteger(number)){
        theValue = theValue + ' %';
      }else{
        theValue =  theValue +  99.99.toLocaleString(userLang).replace(/[0-9]/g,"") + '00 %';
      }

      return theValue;

    } else if (c.label.startsWith('#')) { // not 'Over Commission'

      return parseInt(theValue).toLocaleString(userLang);
    }

    return (Math.round(parseFloat(theValue))).toLocaleString(userLang);

  }

  ngOnDestroy() {
		// prevent memory leak when component destroyed
		this.alive = false;
  }

}
